import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { PersonEntityGrid } from '../features/persons-entity-grid';

export const AllPassengersPage = observer(() => {
  return (
    <AppPage perm="PERM_PERSON_READ" noWrapper>
      <PersonEntityGrid />
    </AppPage>
  );
});
